/**
 * AppHeader — the ONE persistent top bar on every native screen (owner
 * brief: wordmark + menu, identical everywhere, content slides under it,
 * it never scrolls away).
 *
 * Fixed at z-40 (below drawers/sheets at z-50, which own the whole
 * screen while open). It pays the status-bar inset itself and adds a
 * 44pt bar row - pages start below it via --de-app-top (index.css).
 * Replaces the old status-bar scrim: the blur + tint now covers inset
 * AND bar as one piece.
 */
import { Link } from 'react-router-dom';
import { Icon } from '@/components/icons';
import wordmarkUrl from '@/assets/de-wordmark.png';

export function AppHeader({ onMenu }: { onMenu: () => void }) {
  return (
    <header
      className="fixed inset-x-0 top-0 z-40 border-b border-line/40 backdrop-blur-md"
      style={{
        paddingTop: 'var(--de-top-inset, env(safe-area-inset-top))',
        background: 'rgb(var(--de-chrome) / var(--de-chrome-alpha, 0.88))',
      }}
    >
      <div className="flex h-11 items-center justify-between pl-4 pr-1">
        <Link to="/" aria-label="DraftEdge home" className="flex items-center">
          <span
            aria-hidden
            className="block h-[18px] w-[104px] bg-chrome-ink"
            style={{
              WebkitMaskImage: `url("${wordmarkUrl}")`,
              maskImage: `url("${wordmarkUrl}")`,
              WebkitMaskSize: 'contain',
              maskSize: 'contain',
              WebkitMaskRepeat: 'no-repeat',
              maskRepeat: 'no-repeat',
              WebkitMaskPosition: 'left center',
              maskPosition: 'left center',
            }}
          />
        </Link>
        <button
          type="button"
          aria-label="Open menu"
          onClick={onMenu}
          className="flex h-11 w-11 items-center justify-center rounded-card text-chrome-muted active:bg-chrome-ink/10 active:text-chrome-ink"
        >
          <Icon.Menu className="h-5 w-5" />
        </button>
      </div>
    </header>
  );
}
